import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './i18n';
import './i18nHelpers';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();